import React, { useState } from 'react';
import stars from './styles/Group 69.png';
import author1 from './styles/Avatar.png';
import logo1 from './styles/Logo wrap - Copy.png';
import logo2 from './styles/Logo wrap(1) - Copy.png';
import logo3 from './styles/Logo wrap(2) - Copy.png';
import logo4 from './styles/Logo wrap(3) - Copy.png';
import logo5 from './styles/Logo wrap(4) - Copy.png';
import arrow from './styles/Arrow1.png';
import arrow2 from './styles/Arrow2.png';

const TestimonialsRepair = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [logo1, logo2, logo3, logo4, logo5];

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="justify-center bg-Yellow rounded-gr flex flex-col py-[80px] mt-12 items-center sm:mx-0 mx-[20px]">
      <div className="w-full flex flex-col text-center lg:gap-[35px] gap-[30px] font-grFont items-center">
        <img src={stars} className="h-[94.18px] w-[272px]" alt="Stars" />
        <h1 className="lg:text-[48px] text-[36px] font-[700] lg:leading-[60px] leading-[44px] tracking-[2%]">
          Trusted by the people.
        </h1>
        <p className="lg:leading-[44px] lg:text-[36px] leading-[30px] text-[20px] font-[500] lg:font-[400] tracking-[-2%] max-w-[305px] lg:max-w-[700px]">
          We’ve been using Untitled to kick start every new project and can’t imagine working without it.
        </p>
        <div className="flex lg:flex-row flex-col items-center gap-[10px] text-center">
          <img src={author1} className="h-16 w-16" alt="Author" />
          <p className="self-center">Ammar Foley</p>
        </div>
        <div className="xl:flex hidden  flex-row items-center justify-center 2xl:flex gap-2">
          <img src={logo1} alt="Logo 1" />
          <img src={logo2} alt="Logo 2" />
          <img src={logo3} alt="Logo 3" />
          <img src={logo4} alt="Logo 4" />
          <img src={logo5} alt="Logo 5" />
        </div>
        <div className="relative w-[303px] h-[40px] flex flex-row items-center xl:hidden gap-2">
          <div className="cursor-pointer" onClick={handlePrevious}>
            <img src={arrow} alt="Previous" />
          </div>
          <div className="w-full h-full flex justify-center items-center">
            <img
              src={images[currentIndex]}
              className="w-[164.17px] h-[40px] object-cover"
              alt="slider"
            />
          </div>
          <div className="cursor-pointer" onClick={handleNext}>
            <img src={arrow2} alt="Next" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsRepair;
